<template>
    <div class="tipbg" v-show="visible" @click="close">
        <div class="tipBox">
            <img :src="status[type]?status[type]:status['confirm']" alt="">
            <span>{{ title }}</span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'tip',
    data () {
        return {
            visible: false,
            promiseStatus: null,
            title: '',
            showClose: false,
            type: 'confirm',
            status: {
                info: require('@/assets/images/info.png'),
                confirm: require('@/assets/images/confirm.png'),
                error: require('@/assets/images/error.png'),
            },

        }
    },
    methods: {
        tip () {
            const _this = this;
            this.visible = true

            setTimeout(() => {
                this.close();
            }, 2000);
            if (this.showClose) {
                return new Promise((resolve, reject) => {
                    _this.promiseStatus = { resolve, reject };
                });
            }
        },
        close () {
            this.visible = false
            if (this.promiseStatus) {
                this.promiseStatus.resolve()
            }
            this.promiseStatus = null
        },
    }, // 调用方法：  this.$tip('请输入手机号',{showClose:false,type:'info'});this.$tip('请输入手机号')；
}
</script>
<style scoped>
.tipbg {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0);
    z-index: 399;
    user-select: none;
}

.tipBox {
    position: absolute;
    top: 5%;
    left: 50%;
    transform: translate(-50%, -50%);
    -webkit-transform: translate(-50%, -50%);
    z-index: 100;
    padding: 10px 20px;
    line-height: 20px;
    font-size: 14px;
    box-sizing: border-box;
    width: auto;
    background-color: #fff;
    border-radius: 10px;
    /*border-top: 1px solid #383738;*/
    /*border-bottom: 1px solid #383738;*/
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    color: #000;
}

.tipBox img {
    width: 20px;
    height: 20px;
    margin-right: 10px;
}

.tipBox span {
    color: #00c715;
    font-size: 14px;
}
</style>
